export const SHARED_HOSTING_PRODUCTS = {
  BR: [247, 437, 5, 6, 7, 329, 332, 335, 341],
  ES: [174, 5, 6, 7, 8, 9, 10, 211, 212, 213],
};

export const RESELLER_PRODUCTS = {
  BR: [385, 388, 391, 394, 397, 409, 400, 403, 406, 412, 415, 50, 51, 52, 53, 54],
  ES: [50, 51, 52, 53, 54, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 240],
};

export const DEDICATED_SERVERS_PRODUCTS = {
  BR: [56, 58, 60, 64, 57, 59, 61, 65, 62, 63, 311, 320, 317, 323, 314, 326, 461, 464, 467, 470, 473],
  ES: [56, 57, 58, 59, 60, 61, 64, 65, 204, 205, 206, 208, 209, 210, 266, 269, 272, 275, 278],
};

export const VPS_PRODUCTS = {
  BR: [133, 134, 135, 136, 137, 138, 139, 140, 141, 343, 308, 302, 305, 346, 68, 69, 70, 71, 72, 73, 74, 75, 76, 183, 446, 449, 452, 455, 458],
  ES: [201, 202, 203, 133, 134, 135, 136, 137, 138, 139, 140, 141, 215, 216, 251, 254, 257, 260, 263],
};

export const HOSTING_PLUS = {
  BR: [47, 86],
  ES: '',
};

export const SITE_BUILDER = {
  BR: [263, 266, 269, 272, 278, 284],
  ES: [164, 165, 166],
};

export const HOSTING_PRODUCTS_BR = [
  ...SHARED_HOSTING_PRODUCTS.BR,
  ...RESELLER_PRODUCTS.BR,
  ...DEDICATED_SERVERS_PRODUCTS.BR,
  ...VPS_PRODUCTS.BR,
  ...HOSTING_PLUS.BR,
  ...SITE_BUILDER.BR,
];

export const HOSTING_PRODUCTS_ES = [
  ...SHARED_HOSTING_PRODUCTS.ES,
  ...RESELLER_PRODUCTS.ES,
  ...DEDICATED_SERVERS_PRODUCTS.ES,
  ...VPS_PRODUCTS.ES,
  ...HOSTING_PLUS.ES,
  ...SITE_BUILDER.ES,
];
